/**
 * The custom hook that lets you use feature flag actions
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as featureFlagActionsCreator from './actions'

export const useFeatureFlagActions = () => {
  const dispatch = useDispatch()
  const featureFlagActions = useMemo(() => {
    return bindActionCreators(featureFlagActionsCreator, dispatch)
  }, [dispatch])

  return featureFlagActions
}
